import { start } from "tone/build/esm/core/Global";
export class AudioControllerClass {
  constructor() {
    this._started = false;
  }
  static instance() {
    return this._instance = this._instance || new AudioControllerClass();
  }
  async start() {
    if (this._started) {
      return;
    }
    await start();
    return;
  }
}
export const AudioController = AudioControllerClass.instance();
